import React, {useEffect} from 'react';
import Auth0 from 'auth0-js';
import {useConfig} from '@lore/config';
import {Helmet} from 'react-helmet-async';
import RemoveLoadingScreen from "@/pages/RemoveLoadingScreen";

export default function Login(props) {
  const config = useConfig();

  useEffect(() => {
    if (config.auth0.skipAuth0) {
      return;
    }

    const auth0 = new Auth0.WebAuth(config.auth0);
    auth0.authorize({
      prompt: 'none'
    });
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <Helmet>
        <title>Login</title>
      </Helmet>
      {config.auth0.skipAuth0 && (
        <>
          <RemoveLoadingScreen/>
          <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center">
            <h1 className="text-2xl font-bold mb-4">Development Mode</h1>
            <p className="mb-6 text-gray-600">
              Auth0 is skipped. Please use the <code>mintToken.js</code> script to set your token.
            </p>
            <a
              href="/set-token.html"
              className="btn btn-primary"
            >
              Go to set-token.html
            </a>
          </div>
        </>
      )}
    </div>
  );
};
